import { StaticInterface } from '../../../helpers/static-interface';
import TpxBoltsUtils from '../../atoms/shape/bolts.utils';
import Lottie from 'lottie-web';
import { illustration } from './illustration';

export interface ITpxCallToActionUtils {
  loadLottie(parentEl: HTMLElement, json: Object, mobileOrDesktop: string): void;
}

export interface IStaticTpxCallToActionUtils {
  new(...args: any[]): ITpxCallToActionUtils;
  init(): void;
}

/**
 * Call to action utilities
 * @class
 */
export default class TpxCallToActionUtils implements StaticInterface<IStaticTpxCallToActionUtils, typeof TpxCallToActionUtils> {
  constructor(element: HTMLElement) {
    this.loadLottie(element, illustration);
  }

  /**
       * Load lottie animations
       */
  loadLottie(parentEl: HTMLElement, json: Object): void {
    const desktopContainer = parentEl.querySelector('[data-component="call-to-action-block-animation"]');

    if (desktopContainer !== null) {
      const container = desktopContainer;
      //load the animation and autoplay it if user has not set prefers reduced motion on their device
      const prefersReducedMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)').matches : false;
      Lottie.loadAnimation({
        animationData: json,
        container,
        renderer: 'svg',
        loop: true,
        autoplay: !prefersReducedMotion,
      });
    }
  }

  /**
   * Adds the necessary event listeners to support parallax
   */
  static init() {
    [...document.getElementsByClassName('o-cta')].forEach(cta => {
      TpxBoltsUtils.init(cta as HTMLElement);
    });

    document.querySelectorAll('[data-component="call-to-action-block"]').forEach((ctaBlock) => {
      new TpxCallToActionUtils(ctaBlock as HTMLElement);
    })
  }
}